var TemplateAddons = (function () {
    function TemplateAddons() {
    }
    TemplateAddons.prototype.run = function (fc) {
        fc.templateManipulators.postWrapper.push(function (field) {
            if (field && field.templateOptions && (field.templateOptions.addonLeft || field.templateOptions.addonRight)) {
                return 'addons';
            }
        });
    };
    return TemplateAddons;
}());
export { TemplateAddons };
//# sourceMappingURL=addon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/run/addon.js
// module id = 769
// module chunks = 3